import React from 'react'
import PropTypes from 'prop-types'
import styles from './PagesModal.scss'
import Pagination from '../../components/Pagination'
import PagesDrillDownTable from '../../components/PagesDrillDownTable'
import { Breadcrumb, BreadcrumbItem, Modal, ModalHeader, ModalBody } from 'reactstrap'

const PagesModal = props =>
  <div className={styles.PagesModal}>
    <Modal isOpen={props.isOpen} toggle={props.toggle} size='lg'>
      <ModalHeader toggle={props.toggle}>Select Page</ModalHeader>
      <ModalBody>
        <Breadcrumb>
          <BreadcrumbItem active={!props.parentId}>
            <a className={styles.link} onClick={() => props.onDrillDown.bind(props.this, null)()}>
              Root
            </a>
          </BreadcrumbItem>
          {props.parents.map(parent =>
            <BreadcrumbItem active={props.parentId === parent.id} key={parent.id}>
              <a className={props.parentId !== parent.id ? styles.link : ''}
                onClick={() => props.onDrillDown.bind(props.this, parent.id)()}>
                {parent.title}
              </a>
            </BreadcrumbItem>
          )}
        </Breadcrumb>
        <PagesDrillDownTable
          this={props.this}
          currentPageId={props.currentPageId}
          onDrillDown={props.onDrillDown}
          onSelect={props.onSelect}
          pages={props.rows} />
        <Pagination
          total={props.total}
          limit={props.limit}
          currentPage={props.currentPage}
          onChangePage={props.onChangePage}
          />
      </ModalBody>
    </Modal>
  </div>

PagesModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onDrillDown: PropTypes.func.isRequired,
  this: PropTypes.object,
  parents: PropTypes.array,
  parentId: PropTypes.number,
  total: PropTypes.number,
  limit: PropTypes.number,
  currentPage: PropTypes.number,
  currentPageId: PropTypes.number,
  onChangePage: PropTypes.func.isRequired,
  rows: PropTypes.array
}

export default PagesModal



// WEBPACK FOOTER //
// ./src/components/PagesModal/PagesModal.js